import { Link } from 'react-router-dom';
import { buildAiToolEditPath } from '../app-routes';
import type { SchemaLookupConflict, SchemaLookupConflictReason } from './schemaFieldRemoval';

interface SchemaLookupConflictItemProps {
  conflict: SchemaLookupConflict;
  toolName: string;
}

const REASON_DESCRIPTIONS: Record<SchemaLookupConflictReason, string> = {
  user_id_invalid: 'requires a valid customer relationship field',
  schema_removed: 'uses a schema removed by this mapping change',
  invalid_configuration: 'has an invalid configuration',
};

const conflictReason = (conflict: SchemaLookupConflict): string => {
  if (conflict.fieldName) return `returns the exposed field “${conflict.fieldName}”`;
  const reasonDescription = conflict.reason ? REASON_DESCRIPTIONS[conflict.reason] : undefined;
  return reasonDescription ?? 'depends on this schema configuration';
};

export const SchemaLookupConflictItem = ({ conflict, toolName }: SchemaLookupConflictItemProps) => (
  <li>
    <Link to={buildAiToolEditPath(conflict.toolDefinitionId)}>{toolName}</Link>{' '}
    {conflictReason(conflict)}.
  </li>
);
